/* Behaviour for the "Nuestra historia" page sections (mm-about-*). */
(function () {
  if (window.__mmAbout) return;
  window.__mmAbout = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var DESKTOP = 1024;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return Math.max(0, Math.min(1, v)); };

  // One shared scroll/resize loop for every scroll-driven piece on the page.
  var scrollers = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      scrollers.forEach(function (fn) { fn(); });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function clippingAncestor(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var o = getComputedStyle(node).overflowY;
      if (o === 'hidden' || o === 'auto' || o === 'scroll') return true;
      node = node.parentElement;
    }
    return false;
  }

  /* ---------- hero: ken burns + background gradient that shifts on scroll ---------- */
  function initHero(el) {
    var imgs = $$('[data-mm-kb]', el);
    imgs.forEach(function (img) {
      var start = function () {
        img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, fill: 'forwards', easing: 'ease-out' });
        if (!reduced) img.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.1)' }], { duration: 25000, fill: 'forwards', easing: 'ease-out' });
      };
      if (img.complete && img.naturalWidth > 0) start(); else img.addEventListener('load', start, { once: true });
    });
    var top = el.getAttribute('data-top'), bottom = el.getAttribute('data-bottom');
    if (!top || !bottom) return;
    var update = function () {
      var progress = Math.min(window.scrollY / (el.offsetHeight * 0.8), 1);
      var hint = 100 - progress * 40;
      el.style.background = 'linear-gradient(to bottom, ' + top + ', ' + hint + '%, ' + bottom + ')';
    };
    scrollers.push(update);
    update();
  }

  /* ---------- story: sticky card, text scrolls inside it, drawing scrubs with progress ---------- */
  function initStory(el) {
    var frame = $('[data-mm-frame]', el), stick = $('[data-mm-stick]', el);
    var clip = $('[data-mm-clip]', el), text = $('[data-mm-text]', el), viz = $('[data-mm-sviz]', el);
    if (!frame || !clip || !text) return;
    var mode = null, startY = 0, endY = 0, useTransform = false;
    var setP = function (p) { if (viz) viz.style.setProperty('--p', p.toFixed(3)); };

    function setup() {
      frame.style.height = '';
      stick.style.position = ''; stick.style.top = ''; stick.style.transform = '';
      text.style.transform = '';
      mode = window.innerWidth >= DESKTOP && !reduced ? 'desk' : 'mob';
      if (mode === 'desk') {
        var cH = clip.clientHeight;
        var ov = Math.max(0, text.offsetHeight - cH);
        var pad = Math.round(cH * 0.35);
        var framePad = parseInt(getComputedStyle(frame).paddingTop, 10) || 0;
        frame.style.height = (window.innerHeight + pad + ov + pad + framePad) + 'px';
        startY = pad; endY = -(ov + pad);
        var stickTop = Math.max(10, (window.innerHeight - stick.offsetHeight) / 2);
        useTransform = clippingAncestor(stick);
        if (!useTransform) { stick.style.position = 'sticky'; stick.style.top = stickTop + 'px'; }
        el._stickTop = stickTop;
      }
      update();
    }
    function update() {
      if (mode === 'desk') {
        var rect = frame.getBoundingClientRect();
        var range = frame.offsetHeight - window.innerHeight;
        var p = range > 0 ? clamp(-rect.top / range) : 0;
        if (useTransform) {
          var maxShift = frame.offsetHeight - stick.offsetHeight;
          stick.style.transform = 'translateY(' + Math.min(maxShift, Math.max(0, el._stickTop - rect.top)) + 'px)';
        }
        text.style.transform = 'translate3d(0,' + (startY + (endY - startY) * p) + 'px,0)';
        setP(p);
      } else {
        var ov = Math.max(0, text.offsetHeight - clip.clientHeight);
        var r = clip.getBoundingClientRect(), vh = window.innerHeight;
        var p2 = clamp((vh * 0.65 - r.top) / (vh * 0.6));
        text.style.transform = 'translate3d(0,' + (-(ov * p2)) + 'px,0)';
        setP(p2);
      }
    }
    scrollers.push(update);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(setup, 200); });
    if (document.readyState === 'complete') requestAnimationFrame(setup);
    else window.addEventListener('load', function () { requestAnimationFrame(setup); }, { once: true });
    setup();
  }

  /* ---------- team: parallax cards, fade-in title, bio modal ---------- */
  function initTeam(el) {
    var modal = $('[data-mm-tmodal]', el);
    if (modal) {
      document.body.appendChild(modal);
      var imgBox = $('[data-mm-tm-img]', modal), nameEl = $('[data-mm-tm-name]', modal);
      var roleEl = $('[data-mm-tm-role]', modal), bioEl = $('[data-mm-tm-bio]', modal);
      var card = $('[data-mm-tm-card]', modal);
      var open = function () {
        modal.classList.add('is-open');
        document.documentElement.classList.add('mm-lock');
        if (!reduced) {
          modal.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 250, easing: 'ease-out' });
          card.animate([{ opacity: 0, transform: 'scale(.95) translateY(20px)' }, { opacity: 1, transform: 'none' }], { duration: 300, easing: 'ease-out' });
        }
      };
      var close = function () {
        var done = function () { modal.classList.remove('is-open'); document.documentElement.classList.remove('mm-lock'); };
        if (reduced) return done();
        card.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.95) translateY(20px)' }], { duration: 200, easing: 'ease-in' });
        modal.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-in' }).onfinish = done;
      };
      $$('[data-mm-tcard]', el).forEach(function (c) {
        c.addEventListener('click', function () {
          nameEl.textContent = c.getAttribute('data-name') || '';
          roleEl.textContent = c.getAttribute('data-role') || '';
          bioEl.textContent = c.getAttribute('data-bio') || '';
          var src = c.getAttribute('data-img');
          imgBox.innerHTML = src ? '<div><img src="' + src + '" alt=""></div>' : '';
          imgBox.hidden = !src;
          open();
        });
      });
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-mm-tm-close]') || !e.target.closest('[data-mm-tm-card]')) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    }
    if (reduced) return;
    var slots = $$('[data-speed]', el);
    var intro = $('[data-mm-fade]', el);
    if (intro && 'IntersectionObserver' in window) {
      intro.style.opacity = '0';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        intro.animate([{ opacity: 0, transform: 'translateY(40px)' }, { opacity: 1, transform: 'none' }], { duration: 800, easing: 'ease-out', fill: 'forwards' });
        io.disconnect();
      }, { threshold: 0.2 });
      io.observe(intro);
    }
    var update = function () {
      var desk = window.innerWidth >= DESKTOP;
      var vh = window.innerHeight;
      slots.forEach(function (s) {
        if (!desk) { s.style.transform = ''; return; }
        var speed = parseFloat(s.getAttribute('data-speed')) || 0;
        var offset = parseFloat(s.getAttribute('data-offset')) || 0;
        // progress 0 when the card's top hits the viewport bottom, 1 when its bottom leaves the top
        var r = s.getBoundingClientRect();
        var baseTop = r.top - (s._y || 0);
        var p = clamp((vh - baseTop) / (vh + r.height));
        var y = offset + vh * speed * p;
        s._y = y;
        s.style.transform = 'translate3d(0,' + y + 'px,0)';
      });
    };
    scrollers.push(update);
    update();
  }

  /* ---------- values: pause the looping drawings off screen ---------- */
  function initValues(el) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      el.classList.toggle('is-paused', !entries[0].isIntersecting);
    }, { threshold: 0.05 }).observe(el);
  }

  /* ---------- video: click to play, overlay comes back when it ends ---------- */
  function initVideo(el) {
    var btn = $('[data-mm-play]', el), video = $('video', el);
    var shade = $('[data-mm-vshade]', el), ctl = $('[data-mm-vctl]', el);
    if (!btn || !video) return;
    var fade = function (els, to) {
      els.forEach(function (x) {
        if (!x) return;
        x.style.pointerEvents = to ? '' : 'none';
        x.animate([{ opacity: to ? 0 : 1 }, { opacity: to ? 1 : 0 }], { duration: 400, fill: 'forwards' });
      });
    };
    btn.addEventListener('click', function () {
      video.setAttribute('controls', '');
      var p = video.play(); if (p && p.catch) p.catch(function () {});
      fade([shade, ctl], false);
    });
    video.addEventListener('ended', function () {
      video.removeAttribute('controls');
      fade([shade, ctl], true);
    });
  }

  /* ---------- cta: heading appears word by word, then text and button ---------- */
  function initCta(el) {
    var words = $$('[data-w]', el), desc = $('[data-mm-cdesc]', el), btn = $('[data-mm-cbtn]', el);
    if (reduced || !('IntersectionObserver' in window) || !words.length || !words[0].animate) { el.classList.add('is-static'); return; }
    var box = $('[data-mm-ctext]', el);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var stagger = 60, dur = 210;
      words.forEach(function (w, i) {
        var blur = Math.min((i + 1) * 1.5, 10);
        var a = w.animate([{ opacity: 0, filter: 'blur(' + blur + 'px)', transform: 'translateY(6px)' }, { opacity: 1, filter: 'blur(0px)', transform: 'none' }], { duration: dur, delay: i * stagger, easing: 'ease-out', fill: 'forwards' });
        a.onfinish = function () { w.style.opacity = '1'; w.style.filter = 'none'; w.style.transform = 'none'; a.cancel(); };
      });
      var done = (words.length - 1) * stagger + dur;
      if (desc) desc.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 200, delay: done + 80, easing: 'ease-out', fill: 'forwards' });
      if (btn) btn.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 200, delay: done + 200, easing: 'ease-out', fill: 'forwards' });
    }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });
    io.observe(box || el);
  }

  var inits = {
    '[data-mm-ahero]': initHero,
    '[data-mm-astory]': initStory,
    '[data-mm-ateam]': initTeam,
    '[data-mm-avals]': initValues,
    '[data-mm-avideo]': initVideo,
    '[data-mm-acta]': initCta,
  };
  function init(root) {
    Object.keys(inits).forEach(function (sel) {
      $$(sel, root || document).forEach(function (el) {
        if (el._mmAbout) return;
        el._mmAbout = true;
        inits[sel](el);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();